export const ACTIVE_POLICY_EFFECTIVE_TO_ERROR_MESSAGE =
    'Effective To cannot be earlier than today';

export const VOB_SAVE_VALIDATION_ISSUES_PREFIX = 'Please resolve the following issues: ';

export function buildActivePolicyEffectiveToSaveBannerMessage(): string {
    return `${VOB_SAVE_VALIDATION_ISSUES_PREFIX}${ACTIVE_POLICY_EFFECTIVE_TO_ERROR_MESSAGE}; `;
}

export function isActivePolicyEffectiveToBeforeToday(
    effectiveToDate: Date | null
): boolean {
    if (!effectiveToDate) return false;
    const effectiveToDay = new Date(effectiveToDate);
    effectiveToDay.setHours(0, 0, 0, 0);
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    return effectiveToDay < todayStart;
}
